interface InviteMembersFieldWrapperProps {
  label: string;
  children: React.ReactNode;
}

const InviteMembersFieldWrapper = ({ label, children }: InviteMembersFieldWrapperProps) => (
  <div className="flex flex-col gap-2">
    <div className="sticky -top-4 z-10 bg-white py-1">
      <span className="font-medium">{label}</span>
    </div>
    {children}
  </div>
);

export default InviteMembersFieldWrapper;
